import React, { useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import { SnackbarContent } from '@mui/material';

function AppInfo({message,vertical,appInfoOpen,setAppInfoOpen}) {  

  const handleClick = () => {
    setAppInfoOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAppInfoOpen(false);
  };

  // 自动关闭 Snackbar
  React.useEffect(() => {
        
  }, []);

  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical: vertical, horizontal: 'center' }}
        open={appInfoOpen}
        autoHideDuration={4500} // 3秒自动关闭
        onClose={handleClose}
        message=""
        severity="success"
      >
        <SnackbarContent
          style={{
            backgroundColor:"rgba(0, 0, 0, 0.8)",
            color:"#fff",
          }}
          message={message}
        />
      </Snackbar>
    </div>
  );
}

export default AppInfo;
